import request from '@/utils/request'

export function getHolidyList(data) {
  return request({
    method:'post',
    url:`/yzdservice/enterprise/holiday/list`,
    data:data
  })
}

export function addSave(data) {
  return request({
    method:'post',
    url:`/yzdservice/enterprise/holiday/add`,
    data:data
  })
}

export function editSave(data) {
  return request({
    method:'put',
    url:`/yzdservice/enterprise/holiday/edit`,
    data:data
  })
}

export function deleteSave(id) {
  return request({
    method:'delete',
    url:`/yzdservice/enterprise/holiday/removeById/${id}`
  })
}

export function refreshCache() {
  return request({
    method:'post',
    url:`/yzdservice/enterprise/holiday/refreshCache`
  })
}
